<template>
  <div class="register-page">
    <div class="container">
      <div class="col-lg-6 offset-lg-3 col-md-12 offset-md-0 col-sm-12 offset-sm-0 container-register-page">
        <div class="text-center mt10 mb30">
          <img src="/static/ccall.png" class="logo-ccall" width="200" />
        </div>
        <form @submit.prevent="register">
          <div class="form-header">
            {{$t('register.header')}}
          </div>
          <div class="form-group">
            <input type="text" class="form-control" v-model="name" :placeholder="$t('register.name')" :class="{'form-error': errorMessage['name']}" />
            <p v-for="msg in errorMessage['name']" class="text-error">{{msg}}</p>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" v-model="phone" :placeholder="$t('register.phone')" :class="{'form-error': errorMessage['phone']}" />
            <p v-for="msg in errorMessage['phone']" class="text-error">{{msg}}</p>
          </div>
          <div class="form-group">
            <input type="email" class="form-control" v-model="email" :placeholder="$t('register.email')" :class="{'form-error': errorMessage['email']}" />
            <p v-for="msg in errorMessage['email']" class="text-error">{{msg}}</p>
          </div>
          <div class="form-group text-center term-checkbox">
            <label>
              <b-form-checkbox value="orange" v-model="agree">{{$t('register.agree')}}</b-form-checkbox>
              <a href="#" @click="gotoPolicy()">{{$t('register.term')}}</a>
             </label>
            <p v-for="msg in errorMessage['agree']" class="text-error">{{msg}}</p>
          </div>

          <div class="form-group text-center btn-submit">
            <base-button type="submit" class="btn-block" :disabled="name.length ==0 || phone.length == 0 || email.length == 0 || !agree || isDisabled">{{$t('register.register')}}</base-button>
          </div>


          <div class="link-login">Đã có tài khoản? <a href="https://server.ccall.vn">Đăng nhập</a></div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "../components/Button.vue";

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import bButton from 'bootstrap-vue/es/components/button/button';
import bButtonGroup from 'bootstrap-vue/es/components/button-group/button-group';
import bFormCheckboxGroup from 'bootstrap-vue/es/components/form-checkbox/form-checkbox-group';
import bFormCheckbox from 'bootstrap-vue/es/components/form-checkbox/form-checkbox';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.component('b-modal', bModal);
Vue.directive('b-modal', bModalDirective);
Vue.component('b-button', bButton);
Vue.component('b-button-group', bButtonGroup);
Vue.component('b-form-checkbox-group', bFormCheckboxGroup);
Vue.component('b-form-checkbox', bFormCheckbox);

export default {
  components: {
    BaseButton,
  },
  name: 'RegisterPage',
  props: {
    token: [Number, String],
    nameInput: [String],
    emailInput: [String],
    phoneInput: [String],
    agreeInput: [Boolean]
  },
  data() {
    return {
      name: this.nameInput ? this.nameInput : '',
      email: this.emailInput ? this.emailInput : '',
      phone: this.phoneInput ? this.phoneInput : '',
      agree: this.agreeInput ? this.agreeInput : false,
      errorMessage: [],
      isDisabled: false,
    };
  },
  methods: {
    register() {
      /*
      if (this.token) {
        localStorage.setItem('token', this.token);
        top.window.location.href = localStorage.getItem('url');
        setTimeout(() => {
          this.$router.push({name: 'EditPage'});
        }, 100);
        return;
      }
      */
      this.isDisabled = true;
      this.errorMessage = [];
      const bodyFormData = new FormData();
      bodyFormData.append('name', this.name);
      bodyFormData.append('email', this.email);
      bodyFormData.append('phone', this.phone);
      bodyFormData.append('agree', this.agree);
      this.axios.post('/register', bodyFormData).then((response) => {
         if ((response.data.status)) {
           this.$router.push({name:'VerifyPage', params: {token: response.data.data.token, phone: response.data.data.phone}});
         } else {
           this.errorMessage = response.data.data;
           this.isDisabled = false;
         }
      });
    },
    gotoPolicy() {
      this.$router.push({name:'PolicyPage', params: {name: this.name, phone: this.phone, email: this.email, agree: this.agree}});
    }
  },
  mounted() {
    this.name = this.nameInput ? this.nameInput : "";
    this.email = this.emailInput ? this.emailInput : "";
    this.phone = this.phoneInput ? this.phoneInput : "";
    this.agree = this.agreeInput ? this.agreeInput : false;

    /*
    const token = localStorage.getItem('token');
    if (token) {
      this.$router.push({name: 'EditPage'});
    }

    if (this.token) {
      this.axios.get('/getData?token=' + this.token).then((response) => {
        if ((response.data.status)) {
          this.name = response.data.data.name;
          this.email = response.data.data.email;
          this.phone = response.data.data.phone;
        } else {
          this.$router.push({name: 'RegisterPage'});
        }
      });
    }
    */
  }
};
</script>

<style scoped="">
  .btn-block {
    width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/RegisterPage.vue